import { css } from '@emotion/css';
import { Button } from './components/styles/SmbButton.styled';
export const ValidateAddress = ({ onsubmit }: { onsubmit: () => void }) => {
    const handleClick = () => {
            onsubmit()
        // setShowDataSourceModal(true);
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Button
                onClick={handleClick}
                className={css` 
                    display: block;
                    @media (max-width: 768px) {
                        width: 100%;
                    }
                `}
            >
                <span>Get Started</span>
            </Button>
        </div>
    )
}